import { useQuery } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";

// Histórico de reagendamentos de um plantão — só faz sentido consultar quando o modal de
// reagendamento está aberto para um plantão já existente, daí o `enabled`.
export function useReagendamentosQuery(plantaoId, enabled) {
  return useQuery({
    queryKey: ["plantoes", plantaoId, "reagendamentos"],
    queryFn: () => plantoesApi.getReagendamentos(plantaoId),
    enabled: Boolean(enabled && plantaoId),
  });
}
